import React, { useState } from 'react';

function TeamMember(props) {
    const [isPressed, setIsPressed] = useState(false);

    return (
        <>
            <div className="col-lg-4 col-md-6">
                <div
                    className={`team-member${isPressed ? ' team-member-hover-active' : ''}`}
                    onTouchStart={() => setIsPressed(true)}
                    onTouchEnd={() => setIsPressed(false)}
                    onTouchCancel={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                >
                    <div className="team-member-image">
                        <img width="370" height="455" src={props.image.src} alt={props.image.alt} />
                        <img
                            className="team-member-hover-preview"
                            width="370"
                            height="455"
                            src={props.hover?.src || props.image.src}
                            alt=""
                            aria-hidden="true"
                        />
                    </div>
                    <div className="team-member-content">
                        <h5>{props.name}</h5>
                        <h6>{props.designation}</h6>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TeamMember;
